import React, { createContext, useContext } from "react";

const ModalContext = createContext();

export default ModalContext;
